
jQuery(document).ready(function() {    
	textCenter(jQuery);
});

function textCenter($){
	
	$('.btn-o').each((i, e) => {		
		if($(e).attr('aligncenter') == 'true'){
	
			$(e).parent().addClass('text-center')

		}
	})
	
}
